// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3dA7o","alertIcon":"ConfirmModal_alertIcon__1yKtX"};